import { render, staticRenderFns } from "./GradientButton.vue?vue&type=template&id=cfd68f26&scoped=true"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"
import style0 from "./GradientButton.vue?vue&type=style&index=0&id=cfd68f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd68f26",
  null
  
)

export default component.exports